import { OnInit, OnChanges, SimpleChanges, Input, Component, ViewChild, AfterViewInit, Output } from '@angular/core';
import { ReservationQuestion } from '../../model/reservation-question';
import { Question } from '../../model/question';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Answers } from '../../model/answers';
import { BehaviorSubject } from 'rxjs';
import { MatButton } from '@angular/material';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'question-component',
  templateUrl: './question.component.html',
  styleUrls: ['./question.component.css']
})
export class QuestionComponent implements OnInit, OnChanges, AfterViewInit {
  index: number;
  questionFormGroup: FormGroup;
  displayAnswersColumns = ['PatientQuestion', 'Answer'];
  patientAnswersDataSource = new BehaviorSubject<Answers[]>([]);
  questionsFinish: boolean;
  focus: string;
  blockMessage: string;
  @ViewChild('buttonQuestionYes', {static: false}) buttonQuestionYes: MatButton;
  @Output() questionsfinished = new EventEmitter();
  @Output() questionsredo = new EventEmitter();
  // tslint:disable-next-line:no-input-rename
  @Input('reservation-question') reservationQuestion: ReservationQuestion;

  constructor(private formBuilder: FormBuilder) {
    this.reservationQuestion = new ReservationQuestion();
    this.index = 0;
    this.questionsFinish = false;

    this.questionFormGroup = this.formBuilder.group({
      questionValue: ['', [Validators.required]],
      questionObservations: [''],
    });
  }

  getCurrentQuestion(): Question {
    this.patientAnswersDataSource.next(this.reservationQuestion.Answers);
    if (this.reservationQuestion && this.reservationQuestion.Questions
      && this.reservationQuestion.Questions.length > 0) {
        const currentQuestion = this.reservationQuestion.Questions[this.index];
        return currentQuestion;
      } else {
        return new Question();
      }
  }

  keyDownFunction(event) {
    if (event.keyCode === 13) {
      if (!this.questionsFinish) {
        if (this.getCurrentQuestion().LoadValue) {
          this.questionAccept();
        }
      }
    }
  }

  questionYes(): void {
    this.nextQuestion(true);
  }

  questionNo(): void {
    this.nextQuestion(false);
  }

  questionAccept(): void {
    this.nextQuestion(this.questionFormGroup.controls.questionValue.value);
  }

  redo(): void {
    this.blockMessage = '';
    if (this.reservationQuestion.Questions.length > 0) {
      this.reservationQuestion.Answers = [];
        this.questionsFinish = false;
      this.patientAnswersDataSource.next(this.reservationQuestion.Answers);
      this.index = 0;
      this.questionFormGroup = this.formBuilder.group({
        questionValue: ['', [Validators.required]],
        questionObservations: [''],
      });
      this.setFocus();
      this.questionsredo.emit(null);
    } else {
      this.questionsFinish = true;
    }
  }

  private nextQuestion(answerValue: any) {
    if (!this.getCurrentQuestion().LoadValue || 
         this.questionFormGroup.controls.questionValue.valid) {
      const answer = new Answers();
      answer.TypeRestrictionId = this.getCurrentQuestion().TypeRestrictionId;
      answer.ConditionId = this.getCurrentQuestion().ConditionId;
      answer.PatientQuestion = this.getCurrentQuestion().PatientQuestion;
      answer.Value = answerValue;
      if (typeof answerValue === 'boolean') {
        answer.Answer = <boolean>answerValue ? 'Sí' : 'No';
      } else {
        answer.Answer = answerValue;
      }
      this.reservationQuestion.Answers.push(answer);
      this.patientAnswersDataSource.next(this.reservationQuestion.Answers);

      if ((typeof answerValue === 'boolean')
        && ((this.getCurrentQuestion().BlockAffirmation && answerValue === true)
        || (this.getCurrentQuestion().BlockNegation && answerValue === false))) {
        this.blockMessage = this.getCurrentQuestion().BlockMessage;
        this.finishQuestions(true);
      } else if (this.reservationQuestion.Questions.length - 1 > this.index) {
        this.questionFormGroup = this.formBuilder.group({
          questionValue: ['', [Validators.required]],
          questionObservations: [''],
        });
        this.index = this.index + 1;
        this.setFocus();
      } else {
        this.finishQuestions();
      }
    }
  }

  private finishQuestions(isBlock: boolean = false) {
    this.questionsFinish = true;
    this.questionsfinished.emit(isBlock);
  }

  ngOnChanges(changes: SimpleChanges): void  {
    if (!this.reservationQuestion.QuestionsFinish
      && this.reservationQuestion.Answers.length === 0) {
      this.redo();
    }
  }

  setFocus() {
  }

  ngAfterViewInit(): void {
    this.setFocus();
  }

  ngOnInit(): void {
    this.setFocus();
  }

}
